import { motion } from 'motion/react';
import React from 'react';

export interface PuzzlePreviewProps {
  levelData: string[];
  className?: string;
  layoutId?: string;
  onClick?: () => void;
}

const CELL_CLASS_MAP: Record<string, string> = {
  'o': 'puzzle-cell-start',
  'x': 'puzzle-cell-rock',
  'l': 'puzzle-cell-lava',
  's': 'puzzle-cell-stop',
  'e': 'puzzle-cell-end',
};

const PuzzlePreview: React.FC<PuzzlePreviewProps> = ({ 
  levelData, 
  className = '', 
  layoutId,
  onClick 
}) => {
  if (!levelData || !Array.isArray(levelData)) {
    return null;
  }

  return (
    <motion.div 
      className={`puzzle-preview ${className}`}
      layoutId={layoutId}
      onClick={onClick}
      whileHover={onClick ? { scale: 1.05 } : {}}
      whileTap={onClick ? { scale: 0.95 } : {}}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25,
      }}
      style={{
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      {levelData.map((row, rowIndex) => (
        <motion.div 
          key={rowIndex} 
          className="puzzle-row"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ 
            delay: rowIndex * 0.05,
            duration: 0.3,
          }}
        >
          {Array.from(row).map((cell, cellIndex) => {
            const cellClass = CELL_CLASS_MAP[cell] || 'puzzle-cell-empty';
            return (
              <motion.div 
                key={cellIndex} 
                className={cellClass}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ 
                  delay: (rowIndex * row.length + cellIndex) * 0.02,
                  duration: 0.2,
                  type: 'spring',
                  stiffness: 300,
                }}
              />
            );
          })}
        </motion.div>
      ))}
    </motion.div>
  );
};

export default PuzzlePreview;